import { FC, useState } from 'react'
import { FormEntryField, TokenResponse } from '../type'
import { Upload, UploadFile, Image } from 'antd'
import { HttpRequest } from '../http.service'
import { memory } from '../index'
import { AUTHENTICATION_TOKEN } from '../../App.constants'
import { PlusOutlined } from '@ant-design/icons'
import { readUrlAsync } from '../until'
import { RcFile } from 'antd/es/upload'
import { UploadImageResponse } from '../../app/shared/type'
import { UploadChangeParam } from 'antd/es/upload/interface'

export type SendEmailAttachmentsProps = FormEntryField<string[]> & {
  prefix?: string
}

export const SendEmailAttachments: FC<SendEmailAttachmentsProps> = ({value, onChange, prefix}) => {
  const token = memory.get<TokenResponse>(AUTHENTICATION_TOKEN)
  const [fileList, setFileList] = useState<UploadFile<UploadImageResponse[]>[]>([])
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await readUrlAsync(file.originFileObj as RcFile)
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
  }

  const handleChange = ({fileList: newFileList}: UploadChangeParam<UploadFile<UploadImageResponse[]>>) => {
    setFileList(newFileList)
    onChange!(
      newFileList.filter(fl => fl.status === 'done')
        .map(({response}) => (response ?? [])[0]?.filename ?? '')
    )
  }

  return (
    <>
      <Upload
        action={`${new HttpRequest().baseURL}/files/image`}
        name='images'
        headers={{
          Authorization: `${token?.token_type} ${token?.access_token}`
        }}
        listType='picture-card'
        data={{
          prefix
        }}
        fileList={fileList}
        onChange={handleChange}
        onPreview={handlePreview}
      >
        <button style={{border: 0, background: 'none'}} type="button">
          <PlusOutlined/>
          <div style={{marginTop: 8}}>Upload</div>
        </button>
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{display: 'none'}}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(''),
          }}
          src={previewImage}
        />
      )}
    </>
  )
}